import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CalendarDays, Mic, Settings as SettingsIcon, Inbox, LogOut, Plus, ExternalLink } from 'lucide-react';
import EventsManager from '../components/admin/EventsManager';
import SermonsManager from '../components/admin/SermonsManager';
import SettingsManager from '../components/admin/SettingsManager';
import MessagesManager from '../components/admin/MessagesManager';

const TABS = [
  { id: 'events', label: 'Events', icon: CalendarDays },
  { id: 'sermons', label: 'Sermons', icon: Mic },
  { id: 'settings', label: 'Site Info', icon: SettingsIcon },
  { id: 'messages', label: 'Inbox', icon: Inbox },
];

const AdminDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('events');

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#f6f2ea]">
      {/* Top bar */}
      <header className="bg-[#0b2027] text-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full border-2 border-[#c9a24b] flex items-center justify-center">
              <Plus className="h-5 w-5 text-[#c9a24b]" strokeWidth={2.5} />
            </div>
            <div className="leading-none">
              <p className="font-serif-display text-lg">Living Hope Admin</p>
              <p className="text-white/50 text-xs mt-1">{user?.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a href="/" target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors">
              View Site <ExternalLink className="h-4 w-4" />
            </a>
            <button onClick={handleLogout} className="inline-flex items-center gap-2 border border-white/20 hover:border-[#c9a24b] hover:text-[#c9a24b] px-4 py-2 text-sm transition-colors rounded">
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        </div>
      </header>

      {/* Tabs */}
      <div className="bg-white border-b border-[#e4ddd0] sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 flex gap-1 overflow-x-auto">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`inline-flex items-center gap-2 px-5 py-4 text-sm font-600 border-b-2 whitespace-nowrap transition-colors ${tab === t.id ? 'border-[#17565f] text-[#17565f]' : 'border-transparent text-[#5a6b71] hover:text-[#0f2e38]'}`}
            >
              <t.icon className="h-4 w-4" /> {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <main className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        {tab === 'events' && <EventsManager />}
        {tab === 'sermons' && <SermonsManager />}
        {tab === 'settings' && <SettingsManager />}
        {tab === 'messages' && <MessagesManager />}
      </main>
    </div>
  );
};

export default AdminDashboard;
